import { render, staticRenderFns } from "./SensorData.vue?vue&type=template&id=3468846f"
import script from "./SensorData.vue?vue&type=script&lang=js"
export * from "./SensorData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports